export default function Innovation() {
  const features = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Creative Thinking',
      description: 'We encourage out-of-the-box thinking and provide platforms for team members to share innovative ideas that drive pharmaceutical advancement.'
    },
    {
      icon: 'ri-flask-line',
      title: 'Research & Development',
      description: 'Our state-of-the-art R&D facilities enable continuous exploration of new formulations and improved therapeutic solutions.'
    },
    {
      icon: 'ri-cpu-line',
      title: 'Technology Integration',
      description: 'We leverage cutting-edge technology and digital tools to streamline processes and enhance product development efficiency.'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Innovation Awards',
      description: 'We recognize and reward innovative contributions through our internal innovation awards program and patent incentives.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
              INNOVATION
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Pioneering the Future of Healthcare
            </h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Innovation is at the heart of everything we do. We create an environment where creativity thrives, new ideas are welcomed, and breakthrough solutions are born. Our commitment to innovation drives us to continuously improve our products, processes, and services.
            </p>
            <div className="grid sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex-shrink-0">
                    <i className={`${feature.icon} text-white text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="/assets/CultureInno.jpg"
                alt="Innovation in Action"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl">
                  <i className="ri-award-line text-white text-3xl"></i>
                </div>
                <div>
                  <div className="text-3xl font-bold text-gray-900">150+</div>
                  <div className="text-gray-600 text-sm">Patents Filed</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
